/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetJobNotificationSettingsTeammateNotificationStatusFromJSON, GetJobNotificationSettingsTeammateNotificationStatusToJSON, } from './GetJobNotificationSettingsTeammateNotificationStatus.js';
/**
 * Check if a given object implements the GetJobNotificationSettingsResult interface.
 */
export function instanceOfGetJobNotificationSettingsResult(value) {
    if (!('teammates' in value) || value['teammates'] === undefined)
        return false;
    return true;
}
export function GetJobNotificationSettingsResultFromJSON(json) {
    return GetJobNotificationSettingsResultFromJSONTyped(json, false);
}
export function GetJobNotificationSettingsResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'teammates': (json['teammates'].map(GetJobNotificationSettingsTeammateNotificationStatusFromJSON)),
    };
}
export function GetJobNotificationSettingsResultToJSON(json) {
    return GetJobNotificationSettingsResultToJSONTyped(json, false);
}
export function GetJobNotificationSettingsResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'teammates': (value['teammates'].map(GetJobNotificationSettingsTeammateNotificationStatusToJSON)),
    };
}
